import React from "react";

export const CompletedCheckmark = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 20C4.47719 20 0 15.5229 0 10C0 4.47714 4.47719 0 10.0001 0C15.523 0 20.0002 4.47714 20.0002 10C20.0002 15.5229 15.523 20 10.0001 20Z"
        fill="#12B769"
      />
      <path
        d="M7.96536 15.1827L3.6084 10.8258L5.17597 9.25825L7.96536 12.0476L15.0111 5.00195L16.5787 6.56951L7.96536 15.1827Z"
        fill="white"
      />
    </svg>
  );
};
